import { z } from 'zod';

export const roleDtoSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  description: z.string().nullable(),
  isSystem: z.boolean(),
  permissionCodes: z.array(z.string()),
});

export type RoleDto = z.infer<typeof roleDtoSchema>;

export const permissionDtoSchema = z.object({
  code: z.string(),
  description: z.string(),
  scope: z.string(),
});

export type PermissionDto = z.infer<typeof permissionDtoSchema>;

export const roleFormSchema = z.object({
  name: z.string().min(1, 'Role name is required').max(100, 'Name is too long'),
  description: z.string().max(500, 'Description is too long').optional(),
  permissionCodes: z.array(z.string()),
});

export type RoleFormInput = z.infer<typeof roleFormSchema>;
